
import { mapGetters } from 'vuex'

export default {
    name: 'AnimatedQuotesList',
    props: {
        selectedPlanIds: {
            type: Array,
            default: () => []
        },
        showSelectedSummary: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters([
            'quotesInSight',
            'plansMap'
        ]),
        visibleQuotes () {
            return this.quotesInSight.map((planId) => {
                const plan = this.plansMap[planId]
                if (!plan) {
                    return {
                        id: planId,
                        name: `Plan ${planId}`,
                        type: 'Unknown',
                        premium: null
                    }
                }

                return {
                    id: planId,
                    name: plan.name || plan.plan_name || `Plan ${planId}`,
                    type: this.getPlanTypeLabel(plan),
                    premium: plan.monthly_premium || plan.premium
                }
            }).filter(quote => quote)
        },
        selectedPlanNames () {
            return this.selectedPlanIds
                .map((id) => {
                    const plan = this.plansMap[id]
                    return plan ? plan.name || plan.plan_name || `Plan ${id}` : `Plan ${id}`
                })
        }
    },
    methods: {
        isSelected (planId) {
            return this.selectedPlanIds.includes(planId)
        },
        toggleSelection (planId) {
            this.$emit('toggle-selection', planId)
        },
        clearSelection () {
            this.$emit('clear-selection')
        },
        getPlanTypeLabel (plan) {
            const typeMap = {
                0: 'SUPP',
                1: 'PDP',
                2: 'MA(PD)',
                3: 'GP'
            }
            return typeMap[plan.type] || plan.plan_type || 'Plan'
        }
    }
}
